import DeviceErrorModal from '@components/Modals/DeviceError';
import MeetingErrorModal from '@components/Modals/MeetingError';
import Spinner from '@components/Spinner';
import { modalLayoutState } from '@stores/selectors/modal';
import { useAtomValue } from 'jotai';
import type { FC, PropsWithChildren } from 'react';

const ModalLayout: FC<PropsWithChildren> = ({ children }) => {
  const { loading, deviceError, meetingError } = useAtomValue(modalLayoutState);

  return (
    <>
      {loading && <Spinner />}
      {deviceError && <DeviceErrorModal />}
      {meetingError && <MeetingErrorModal />}
      {children}
    </>
  );
};

export default ModalLayout;
